var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"input-wrap -date"},[_c('i',{staticClass:"ico--calendar"}),_c('input',{ref:_vm.mode,attrs:{"type":"text","placeholder":_vm.placeholder,"readonly":_vm.readonly},domProps:{"value":_vm.date}}),(_vm.date && _vm.withReset)?_c('i',{staticClass:"ico--reset-data",on:{"click":function($event){return _vm.resetData()}}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }